import React from 'react';
import PDF2 from './DanielleMattonResume.pdf';
import PDF from './Danielle Matton Resume.pdf';

export const Home = () => {
    return (
        <div className="home" id="home">
            <div className="container">
                <div className="row">
                    <div className="home-content">
                        <div className="block">
                            <h1>Hi, I'm Dani.</h1>
                            <h3 className="home-description">Software Engineer/Frontend Fanatic</h3>
                            <div className="cv-btn">
                                <a href={PDF} target="_blank" rel="noopener noreferrer">my resume</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
